"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getConfigByReseller = exports.getConfig = void 0;
const deepmerge_1 = __importDefault(require("deepmerge"));
const config_1 = __importDefault(require("./data/config"));
function getConfig() {
    return config_1.default;
}
exports.getConfig = getConfig;
function getConfigByReseller(reseller) {
    let resellerValues = (reseller && config_1.default[reseller]) || {};
    return deepmerge_1.default(config_1.default.default, resellerValues);
}
exports.getConfigByReseller = getConfigByReseller;
